var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"redis-wrap"},[_c('el-button',{staticClass:"leader-common-button",on:{"click":function($event){return _vm.refresh()}}},[_vm._v("刷新Redis")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }